import { DebitNoteRepository } from "../../repositories/DebitNoteRepository";
import { DebitNoteCountsEntity } from "../../entities/DebitNoteEntity";

/**
 * Get Debit Note Counts Use Case
 * Retrieves counts for all debit note categories for dashboard cards
 */
export class GetDebitNoteCountsUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<DebitNoteCountsEntity> {
    return await this.repository.fetchDebitNoteCounts(params);
  }
}
